//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapGetters,
} from 'vuex';
import download from '../../../../../common/resources/downloads';
import ApuracaoTabela from './ApuracaoTabelaDash';
import ReivindicacaoTabela from './ReivindicacaoTabelaDash';
import apuracaoMixin from './apuracao';
import { getMoney } from '../../../../../common/functions/helpers';
import { skipLoading } from '../../../../../common/functions/loading';

export default {
  name: 'DashboardApuracao',
  mixins: [apuracaoMixin],
  data() {
    return {
      reivindicacoes: [],
      idMeta: 0,
      status: '',
      deletar: true,
      consolidadoApuracao: {},
      filtros: {},
      periodo: null,
      idUnidadeNegocio: null,
      carregado: false,
      carregandoBox: false,
      carregandoTableApuracoes: false,
      carregandoTableReivindicacoes: false,
      bloquearConsulta: false,
      paginasApuracao: 0,
      paginasReivindicacao: 0,
      buscarComParametro: false,
      totalPage: 0,
    };
  },
  props: {
    parametros: {
      type: Object,
      default: {},
    },
  },
  components: {
    ApuracaoTabela,
    ReivindicacaoTabela,
  },
  methods: {
    getMoney,
    downloadEvidencia(params) {
      const idRequisicao = params.id;
      const getBasePath = params.getBasePath;
      const resource = download(this.$http);
      resource.download(getBasePath,
        {
          limit: 500,
          url: 'download',
          id: idRequisicao,
          parametrosConsulta: {},
        })
        .then(() => {
          this.$toast.create(this.$t('message.download_efetuado'), 'snack', 3E3);
        })
        .catch(() => {
          this.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
        });
    },
    requestCarregarConsolidadoApuracao() {
      skipLoading();
      this.carregandoBox = true;
      this.dashboardApuracaoResources.listarDashApuracao(this.filtros)
        .then((response) => {
          this.consolidadoApuracao = {};
          response.data.forEach((item) => {
            this.consolidadoApuracao[item.status.toLowerCase()] = item.consolidado;
          });
          this.carregandoBox = false;
        })
        .catch((err) => {
          this.$error(this, err);
          this.carregandoBox = false;
        });
      return this;
    },
    requestCargaPeriodos() {
      return new Promise((resolve, reject) => {
        skipLoading();
        this.dashboardApuracaoResources.listarPeriodos()
          .then((response) => {
            this.periodos = response.data;
            resolve();
          }).catch(reject);
      });
    },
    requestGetUnidadesNegocio() {
      return new Promise((resolve, reject) => {
        skipLoading();
        this.usuarioUnidadeNegocioResources.listarAtivos()
          .then((response) => {
            this.unidadesNegocio = response.data;
            resolve();
          }).catch(reject);
      });
    },
    requestCargaDash() {
      this.$refs.apuracaoTabela.refazPaginacao();
      if (this.periodo) {
        this.filtros.periodo = this.periodo;
      } else {
        delete this.filtros.periodo;
      }
      if (this.idUnidadeNegocio) {
        this.filtros.idUnidadeNegocio = this.idUnidadeNegocio;
      } else {
        delete this.filtros.idUnidadeNegocio;
      }

      this.requestCarregarReivindicacoes();
      this.requestCarregarConsolidadoApuracao();
    },
    requestCarregarApuracoes(filtros, pagina = 0, cb) {
      this.filtros = Object.assign(this.filtros, filtros || {});

      this.bloquearConsulta = true;
      const merged = Object.assign({}, this.filtros);
      Object.assign(merged, filtros);
      merged.tamanhoPagina = 20;
      merged.numeroPagina = pagina;

      skipLoading();
      this.carregandoTableApuracoes = true;
      this.dashboardApuracaoResources.listarApuracoes(merged)
        .then((response) => {
          this.bloquearConsulta = false;
          this.carregandoTableApuracoes = false;
          this.apuracoes = response.data.resposta;
          this.apuracoes.forEach((el, index) => {
            el.index = index;
          });
          this.totalPage = response.data.quantidadeRegistrosPagina;
          const qtdeRegistros = response.data.quantidadeRegistrosPagina;
          this.paginasApuracao = Math.ceil(qtdeRegistros / merged.tamanhoPagina);
          if (cb) {
            cb();
          }
        }).catch((err) => {
          this.bloquearConsulta = false;
          this.carregandoTableApuracoes = false;
          this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    requestCarregarReivindicacoes(filtros, pagina = 0, cb) {
      const merged = Object.assign({}, this.filtros);
      Object.assign(merged, filtros);
      merged.tamanhoPagina = 20;
      merged.numeroPagina = pagina;
      skipLoading();
      this.carregandoTableReivindicacoes = true;
      this.dashboardApuracaoResources.listarReivindicacoes(merged)
        .then((response) => {
          this.carregandoTableReivindicacoes = false;
          this.reivindicacoes = response.data.resposta;
          const qtdeRegistros = response.data.quantidadeRegistrosPagina;
          this.paginasReivindicacao = Math.ceil(qtdeRegistros / merged.tamanhoPagina);
          if (cb) {
            cb();
          }
        })
        .catch((err) => {
          this.carregandoTableReivindicacoes = false;
          this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    abrirSideBar(row) {
      const eventData = {
        idMeta: row.idMeta,
        status: row.status,
        deletar: row.deletar,
        fecharSideBar: this.fecharSideBar,
      };
      this.$emit('APURACAOTABELA_UPLOAD_EVIDENCIA', eventData);
    },
    fecharSideBar() {
      this.idMeta = 0;
    },
    filtrarFluxos(filtro) {
      this.$refs.apuracaoTabela.refazPaginacao();
      if (this.buscarComParametro) {
        this.requestCarregarApuracoes(this.filtrosPorParametros());
        this.buscarComParametro = false;
      } else {
        this.requestCarregarApuracoes(filtro);
      }
    },
    filtrarFluxosReivindicacao(filtro) {
      this.$refs.reivindicacaoTabela.refazPaginacao();
      this.requestCarregarReivindicacoes(filtro);
    },
    filtrosPorParametros() {
      const filter = { status: 'AGUARDANDO_APROVACAO' };
      filter.meuPassoPendente = true;
      if (this.parametros && this.parametros.idApuracao) {
        filter.idApuracao = this.parametros.idApuracao;
      }
      return filter;
    },
    temParametro() {
      return this.parametros && this.parametros.idApuracao;
    },
    abreCarrega() {
      if (this.carregado) {
        return;
      }

      window.setTimeout(() => {
        this.requestCargaPeriodos()
          .then(this.requestGetUnidadesNegocio)
          .then(() => {
            this.carregado = true;
            this.requestCarregarConsolidadoApuracao();
            if (this.temParametro()) this.buscarComParametro = true;
            delete this.filtros.idApuracao;
          })
          .catch((err) => {
            this.$toast.create(this.$t(err), 'snack', 3E3);
          });
      });
    },
  },
  computed: {
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
  },
  mounted() {
    this.buscarPendencias();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/DashboardApuracao.vue?vue&type=script&lang=js&